module.exports = __webpack_public_path__ + "static/img/10bg_2.f7aea84.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/10bg_2.png
// module id = 609
// module chunks = 1